import { getExclusion } from 'ha/utils/exclusionDate';
import { WEEK_IN_MS } from 'ha/helpers/hadate';
import { TypesAlgolia, KindsAlgolia } from 'ha/constants/Room';
import { ListingPhotoKind } from 'ha/constants/Listing';
import { AlgoliaListing } from 'ha/services/apiV2/types/AlgoliaListing';

import { NormalizedListing } from '../Types';

interface NormalizeOptions {
  currency: string;
  currencyRate: number;
}

const normalizeListing = ({ currency, currencyRate }: NormalizeOptions) => (
  item: AlgoliaListing,
): NormalizedListing => {
  let photos = item.photos || [];

  photos = photos.map(photo => {
    let formattedPhotos = photo.replace('.com/images', '.com/v2/images');

    formattedPhotos = formattedPhotos.replace(
      `kind=${ListingPhotoKind.Large}`,
      `kind=${ListingPhotoKind.SearchPagePreview}`,
    );

    return formattedPhotos;
  });

  return {
    ...item,

    // TODO: Refactor components so only one id is used
    id: item.internalID,
    entityId: item.internalID,
    kind: KindsAlgolia[item.kind],
    type: TypesAlgolia[item.type],
    advertiser: { avatarURL: item.advertiserAvatar },
    currency,
    listingPath: item.path,
    previewImage: item.thumbnailURL,
    price: currencyRate * item.priceEUR * 100,
    isNew: Date.now() - item.creationDateTS * 1000 < WEEK_IN_MS,
    minimalRentalPeriod: item.minimumStayMonths,
    exclusions: [getExclusion(item.dateFrom, item.dateTo)],

    latitude: (item._geoloc && item._geoloc.lat) || null,
    longitude: (item._geoloc && item._geoloc.lng) || null,

    photos,
  };
};

export default normalizeListing;
